// Single source of truth for the currently-deployed release metadata.
//
// Update these THREE constants on each deploy and every stamp across the
// app (login footer + sign-in card, Revision History cover, Internal
// Guide cover + history table, Client Guide cover + history table,
// Testing Plan cover) re-renders automatically. This is the ONLY place
// the live release string should be edited.
//
// How to bump:
//   1) Bump APP_VERSION (semver-ish).
//   2) Set APP_RELEASE_DATE to today in "D Month YYYY" format.
//   3) Set APP_DEPLOYED_AT to the wall-clock time with tz suffix
//      (e.g. "6:20 AM PDT").
//   4) Add the new row to REVISIONS in RevisionHistoryPage.js and the
//      matching table rows in InternalGuidePage.js + ClientGuidePage.js.
//
// Derived strings (LATEST_RELEASE_LABEL, RELEASE_STAMP_LONG,
// RELEASE_STAMP_SHORT) are built from the three primitives; do NOT
// hand-edit them.
export const APP_VERSION = "2.06";
export const APP_RELEASE_DATE = "25 August 2026";
export const APP_DEPLOYED_AT = "Pending deploy";

// Footer / login-card label: "Release: 30 April 2026 · 6:20 AM PDT · v1.7"
export const LATEST_RELEASE_LABEL =
  `Release: ${APP_RELEASE_DATE} · ${APP_DEPLOYED_AT} · v${APP_VERSION}`;

// Cover-page stamp used by Internal Guide + Client Guide + Testing Plan:
//   "Release v1.7 · 30 April 2026 · Deployed 6:20 AM PDT"
export const RELEASE_STAMP_LONG =
  `Release v${APP_VERSION} · ${APP_RELEASE_DATE} · Deployed ${APP_DEPLOYED_AT}`;

// Short form some templates prefer:
//   "30 April 2026 · Release v1.7 · Deployed 6:20 AM PDT"
export const RELEASE_STAMP_SHORT =
  `${APP_RELEASE_DATE} · Release v${APP_VERSION} · Deployed ${APP_DEPLOYED_AT}`;
